import {enqueueSnackbar} from 'notistack'
import {FC} from 'react'
import {useFormContext} from 'react-hook-form'
import Swal from 'sweetalert2'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {deleteRoomService} from '../../services/deleteRoom.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'
const getSnackBar = (message: String, variant: boolean) => {
  enqueueSnackbar(message, {
    variant: variant ? 'success' : 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}
const SubMenuRooms: FC = () => {
  const {reset} = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const handleNew = () => {
    reset()
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
      content: {
        headerPanel: 'form-new-room',
      },
    }
    changeCurrentTabItem(obj)
  }
  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        let id = [{Id: currentTabItem.idToEdit}]
        changeCurrentTabItem({...currentTabItem, loadingTable: true})

        const data = await deleteRoomService(id)
        if (!data.data.error) {
          const obj: TabModel = {
            ...currentTabItem,
            idToEdit: '',
            loadingTable: false,
          }
          changeCurrentTabItem(obj)
          getSnackBarToast('Se eliminó con éxito', 'success')
        } else {
          changeCurrentTabItem({...currentTabItem, loadingTable: false})

          getSnackBarToast(data.data.message, 'error')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }
  const handleList = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      content: {
        headerPanel: 'table-rooms',
      },
    }
    changeCurrentTabItem(obj)
  }

  let getDisabledDelete = currentTabItem.idToEdit ? (currentTabItem.showPanel ? true : false) : true
  return (
    <ButtonWrapper>
      {currentTabItem.content.headerPanel !== 'form-new-room' && (
        <Button label='Nuevo' onClick={() => handleNew()} />
      )}
      {(currentTabItem.content.headerPanel === 'form-new-room' ||
        currentTabItem.content.detailPanel === 'form-edit-room') && (
        <Button typeBtn='submit' label='Guardar' />
      )}
      <Button label='Limpiar' onClick={() => reset()} />
      <Button label='Eliminar' disabled={getDisabledDelete} onClick={() => handleDelete()} />
      {/* <Button label='Actualizar' onClick={()=>handleShowNewForm()}/> */}
      {currentTabItem.content.headerPanel === 'form-new-room' && (
        <Button label='Volver al listado' classNameProp='ms-auto' onClick={() => handleList()} />
      )}
    </ButtonWrapper>
  )
}

export {SubMenuRooms}
